Service = App.loadClass 'core::Angular/Service'

class exports.GenerateKeyFieldsService extends Service
    constructor: (@http, @rootScope) ->
        undefined

    getCompanies: () =>
        @http.post 'backend/admin/new-tools/generate-key-fields/get-companies'

    getYears: () =>
        @http.post 'backend/admin/new-tools/generate-key-fields/get-years'

    getAlgorithms: () =>
        @http.post 'backend/admin/new-tools/generate-key-fields/get-algorithms'

    buildMatViews: (companyId, advisorId, year, algorithm) =>
        @http.post 'backend/admin/new-tools/generate-key-fields/build-mat-views',
            companyId: companyId
            advisorId: advisorId
            year: year
            algorithm: algorithm

    generate: (companyId, advisorId, year, algorithm) =>
        @http.post 'backend/admin/new-tools/generate-key-fields/generate',
            companyId: companyId
            advisorId: advisorId
            year: year
            algorithm: algorithm

    saveKeyFields: (companyId, advisorId, year, fields) =>
        @http.post 'backend/admin/new-tools/generate-key-fields/save-fields',
            companyId: companyId
            advisorId: advisorId
            year: year
            fields: fields

    deleteKeyFields: (companyId, advisorId, year) =>
        @http.post 'backend/admin/new-tools/generate-key-fields/delete-fields',
            companyId: companyId
            advisorId: advisorId
            year: year
